<template>
  <div class='massLoss-list'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='110px' :inline='true'
               class='demo-form-inline flex1' ref='searchForm'>
        <el-form-item label='台账月：'>
          <el-input v-model='searchForm.standingBookMonth' size='mini' placeholder='请输入台账月'
                    @paste.native.capture.prevent="
              value => {
                return searchCopyFormat(value, 'standingBookMonth');
              }
            "></el-input>
        </el-form-item>
        <el-form-item label='交车时间：'>
          <el-date-picker v-model="searchForm.deliveryStartDate" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange2" type="date" placeholder="开始日期" />
          <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
          <el-date-picker v-model="searchForm.deliveryEndDate" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange2" type="date" placeholder="结束日期" />
        </el-form-item>
        <el-form-item label='计划时间：'>
          <el-date-picker v-model="searchForm.plannedStartDate" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange1" type="date" placeholder="开始日期" />
          <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
          <el-date-picker v-model="searchForm.plannedEndDate" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange1" type="date" placeholder="结束日期" />
        </el-form-item>
        <el-form-item label='委托单位：'>
          <el-input v-model='searchForm.consignorName' size='mini' placeholder='请输入委托单位'></el-input>
        </el-form-item>
        <el-form-item label='运输方式：'>
          <el-select v-model="searchForm.transportationTerms" filterable size="mini" placeholder="请选择运输方式">
            <el-option label="全部" value=""></el-option>
            <el-option label="公路" value="1"></el-option>
            <el-option label="水路" value="2"></el-option>
            <el-option label="水路联运" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
       <el-row>
         <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
           <span @click='exportData'>导出数据</span>
         </el-col>
       </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >
          <el-table-column prop='brandName' label='品牌' align='center' min-width='100px' />
          <el-table-column prop='transportationTerms' label='运输方式' align='center' min-width='100px' :formatter="getTransport"/>
          <el-table-column prop='totalCount' label='统计总数量' align='center' min-width='100px' />
          <el-table-column prop='totalPrice' label='统计总金额' align='center' min-width='100px' />
          <el-table-column label='进港环节' align='center' min-width='100px'>
            <el-table-column prop='line1' label='线路' align='center' min-width='100px' show-overflow-tooltip/>
            <el-table-column prop='jg_Count' label='数量' align='center' min-width='100px' />
            <el-table-column prop='jg_Percent' label='数量占比（%）' align='center' min-width='120px' />
            <el-table-column prop='jg_Price' label='运费' align='center' min-width='100px' />
            <el-table-column prop='jg_Average' label='平均价' align='center' min-width='100px' />
          </el-table-column>
          <el-table-column label='水运环节' align='center' min-width='100px'>
            <el-table-column prop='line2' label='线路' align='center' min-width='100px' show-overflow-tooltip/>
            <el-table-column prop='sl_Count' label='数量' align='center' min-width='100px' />
            <el-table-column prop='sl_Percent' label='数量占比（%）' align='center' min-width='120px' />
            <el-table-column prop='sl_Price' label='运费' align='center' min-width='100px' />
            <el-table-column prop='sl_Average' label='平均价' align='center' min-width='100px' />
          </el-table-column>
          <el-table-column label='末端公路' align='center' min-width='100px'>
            <el-table-column prop='line3' label='线路' align='center' min-width='100px' show-overflow-tooltip/>
            <el-table-column prop='mdgl_Count' label='数量' align='center' min-width='100px' />
            <el-table-column prop='mdgl_Percent' label='数量占比（%）' align='center' min-width='120px' />
            <el-table-column prop='mdgl_Price' label='运费' align='center' min-width='100px' />
            <el-table-column prop='mdgl_Average' label='平均价' align='center' min-width='100px' />
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>
  </div>
</template>
<script>
import {getSrfdPageList} from "@/service/getData";

export default {
  data(){
    return{
      searchForm: {
        standingBookMonth: '',
        deliveryStartDate: '',
        deliveryEndDate: '',
        plannedStartDate: '',
        plannedEndDate: '',
        consignorName: '',
        transportationTerms: '',
        page: 1,
        rows: 10,
      },
      tableLoading: false,
      tableData: [],
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      total: 0,
    }
  },
  methods:{
    exportData() {
      window.exportExcelAll('get', '/statistical/report/exportExcel', {
        ...this.searchForm
      });
    },
    searchCopyFormat(value, flag) {
      let splitArr = value.clipboardData.getData('Text').replace(/\s/g, ',').split(',');
      splitArr = splitArr.filter(item => item);
      splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
      switch (flag) {
        case 'standingBookMonth':
          this.searchForm.standingBookMonth = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
          break;
      }
    },
    getTransport(r, c, cellValue) {
      switch (cellValue) {
        case 1:
          return '公路';
        case 2:
          return '水路';
        case 3:
          return '水路联运';
      }
    },
    //查询
    searchBtn(){
      this.searchForm.page = 1
      this.getTableData()
    },
    // 获取表格数据
    async getTableData() {
      if (this.searchForm.consignorName) {
        this.tableLoading = true;
        const res = await getSrfdPageList({
          standingBookMonth: this.searchForm.standingBookMonth,
          deliveryStartDate: this.searchForm.deliveryStartDate ? this.searchForm.deliveryStartDate : '',
          deliveryEndDate: this.searchForm.deliveryEndDate ? this.searchForm.deliveryEndDate : '',
          plannedStartDate: this.searchForm.plannedStartDate ? this.searchForm.plannedStartDate : '',
          plannedEndDate: this.searchForm.plannedEndDate ? this.searchForm.plannedEndDate : '',
          consignorName: this.searchForm.consignorName,
          transportationTerms: this.searchForm.transportationTerms,
          page: this.searchForm.page,
          rows: this.searchForm.rows,
        });
        this.tableLoading = false;
        if (res.status === -1) return this.$message.warning(res.message)
        this.tableData = res.data;
        this.total = res.total;
      } else {
        this.$message.warning('请先输入委托单位！');
      }
      
    },
    //重置
    resetBtn(){
      for (const argumentsKey in this.searchForm) {
        this.searchForm[argumentsKey] = '';
      }
      this.searchForm.page = 1;
      this.searchForm.rows = 10;
    },
    contractSizeChange(row) {
      this.searchForm.rows = row;
      this.searchForm.page = 1;
      this.getTableData();
    },
    contractCurrentChange(page) {
      this.searchForm.page = page;
      this.getTableData();
    },
    // 交车开始-结束日期验证
    dateChange2(val) {
      if (this.searchForm.deliveryEndDate && this.searchForm.deliveryStartDate && (this.searchForm.deliveryEndDate <= this.searchForm.deliveryStartDate)) {
        if (val == this.searchForm.deliveryEndDate) this.searchForm.deliveryEndDate = '';
        if (val == this.searchForm.deliveryStartDate) this.searchForm.deliveryStartDate= '';
        this.$forceUpdate();
        return this.$message.warning('结束日期必须大于开始日期！');
      }
    },
    // 计划开始-结束日期验证
    dateChange1(val) {
      if (this.searchForm.plannedEndDate && this.searchForm.plannedStartDate && (this.searchForm.plannedEndDate <= this.searchForm.plannedStartDate)) {
        if (val == this.searchForm.plannedEndDate) this.searchForm.plannedEndDate = '';
        if (val == this.searchForm.plannedStartDate) this.searchForm.plannedStartDate = '';
        this.$forceUpdate();
        return this.$message.warning('结束日期必须大于开始日期！');
      }
    },
  }
}
</script>


<style scoped lang="scss">
.massLoss-list{
  padding: 20px 15px 0 25px;
}
</style>
